export { default } from './TitleTextImage.js';
